import { CONFIG } from "../../config";
import { IReportRequest } from "../../interfaces/requestReport.interface";
import { TimeFormat } from "../../interfaces/timeFormat.enum";
import { getTokenizedAxios } from "../../utils/axiosWithTokenGen";
import { ReportName } from "../../interfaces/reports.interface";

export async function getSalesOverviewReportFromServer(
  reportRequest: IReportRequest
): Promise<{
  transactionsReport: string;
  isEmailed: boolean;
  isEmpty: boolean;
}> {
  const axios = await getTokenizedAxios();
  const path = "/transactions/report";
  return axios
    .get(CONFIG.SERVER.BASE_URL + path, {
      params: { ...reportRequest, ["Api-Version"]: "2024-01-21" },
    })
    .then((data) => data.data);
}
export async function getTransactionsOverviewReportFromServer(
  reportRequest: IReportRequest
): Promise<{
  transactionsReport: string;
  isEmailed: boolean;
  isEmpty: boolean;
}> {
  const axios = await getTokenizedAxios();
  const path = "/transactions/report/list";
  return axios
    .get(CONFIG.SERVER.BASE_URL + path, {
      params: { ...reportRequest, ["Api-Version"]: "2024-01-21" },
    })
    .then((data) => data.data);
}
export async function getPayoutReportFromServer(
  reportRequest: IReportRequest
): Promise<{
  transactionsReport: string;
  isEmailed: boolean;
  isEmpty: boolean;
}> {
  const axios = await getTokenizedAxios();
  const path = "/transactions/report/payout";
  return axios
    .get(CONFIG.SERVER.BASE_URL + path, {
      params: { ...reportRequest, ["Api-Version"]: "2024-01-21" },
    })
    .then((data) => data.data);
}
export async function getAccountingReportFromServer(
  reportRequest: IReportRequest
): Promise<{
  transactionsReport: string;
  isEmailed: boolean;
  isEmpty: boolean;
}> {
  const axios = await getTokenizedAxios();
  const path = "/transactions/report/accounting";
  return axios
    .get(CONFIG.SERVER.BASE_URL + path, {
      params: { ...reportRequest, ["Api-Version"]: "2024-01-21" },
    })
    .then((data) => data.data);
}

// Analytics Reports

export type ApplePerformanceReportRequest = {
  reportFrequency: "monthly" | "quarterly";
  returnType: "buffer" | "url";
};
export async function getApplePerformanceReportFromServer({
  reportFrequency,
  returnType = "url",
}: {
  reportFrequency: "monthly" | "quarterly";
  returnType: "buffer" | "url";
}): Promise<{
  value: string;
  returnType: "buffer" | "url";
  // isEmailed: boolean;
  // isEmpty: boolean;
}> {
  const axios = await getTokenizedAxios();
  const path = "/ios/reports/performance";
  return axios
    .get(CONFIG.SERVER.BASE_URL + path, {
      params: { reportFrequency, returnType },
    })
    .then((data) => data.data);
}

export type MainAnalyticsReportRequest = {
  startDate?: string;
  endDate?: string;
  formatType?: "PDF" | "JSON" | "XLSX" | "CSV";
  receiveViaEmail?: boolean;
  email?: string;
  isCustomTime?: "true" | "false";
  timeFormat?: TimeFormat;
  sheets?: ReportName[];
};

export type AnalyticsReportJobStatus =
  "ready" | "pending" | "failed" | "missing";

export type AnalyticsReportJob = {
  status?: AnalyticsReportJobStatus;
  urlLink?: string;
  isEmailed?: boolean;
  isEmpty?: boolean;
  message?: string;
  data?: string;
};

const ANALYTICS_REPORT_PATH = "/businesses/analytics/start";

export function analyticsReportStatusParams(
  request: Pick<MainAnalyticsReportRequest, "startDate" | "endDate" | "sheets">
): { start?: string; end?: string; sheets?: string } {
  return {
    start: request.startDate,
    end: request.endDate,
    ...(request.sheets?.length ? { sheets: request.sheets.join(",") } : {}),
  };
}

export async function getMainAnalyticsReportFromServer({
  startDate,
  endDate,
  formatType,
  receiveViaEmail,
  email,
  isCustomTime,
  timeFormat,
  sheets,
}: MainAnalyticsReportRequest): Promise<AnalyticsReportJob> {
  const axios = await getTokenizedAxios();
  return axios
    .post(CONFIG.ADMIN_SERVER.BASE_URL + ANALYTICS_REPORT_PATH, {
      start: startDate,
      end: endDate,
      receiveViaEmail,
      email,
      sheets,
    })
    .then((data) => data.data);
}

export async function getMainAnalyticsReportStatusFromServer(
  request: Pick<MainAnalyticsReportRequest, "startDate" | "endDate" | "sheets">
): Promise<AnalyticsReportJob> {
  const axios = await getTokenizedAxios();
  return axios
    .get(CONFIG.ADMIN_SERVER.BASE_URL + ANALYTICS_REPORT_PATH, {
      params: analyticsReportStatusParams(request),
    })
    .then((data) => data.data);
}
